var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61534 2.34783H5.76917C5.89656 2.34783 5.99994 2.23096 5.99994 2.08696V0.329478C5.99994 0.192783 5.90694 0.0790435 5.78648 0.0693913C5.41933 0.039913 4.70211 0 4.18634 0C2.7692 0 1.84614 0.96 1.84614 2.7047V4.43478H0.230767C0.103384 4.43478 0 4.55165 0 4.69565V6.52174C0 6.66574 0.103384 6.78261 0.230767 6.78261H1.84614V11.7391C1.84614 11.8831 1.94952 12 2.0769 12H3.69227C3.81965 12 3.92304 11.8831 3.92304 11.7391V6.78261H5.58964C5.70733 6.78261 5.8061 6.6827 5.81902 6.55044L5.99855 4.72435C6.01379 4.56991 5.90671 4.43478 5.76917 4.43478H3.92304V3.13043C3.92304 2.69817 4.23296 2.34783 4.61534 2.34783Z",
    fill: "#B3B3B3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-facebook.3a0dc2e3.svg";
export { ForwardRef as ReactComponent };